import styled, { css } from 'styled-components';

// Import styles utilities
import { media, flex } from 'components/styles';

export const ListWrapper = styled.div`
	width: 100%;
	max-width: 123rem;
	margin: 4rem auto;
`;

export const ListElement = styled.div`
	${flex({ ai: 'flex-start', fd: 'column' })}
	width: 100%;
	margin-bottom: ${({ configurator }) => (configurator ? 2.5 : 1.5)}rem;

	${media.min.min(css`
		margin-bottom: ${({ configurator }) => (configurator ? 5 : 3)}rem;
		${flex({ jc: 'space-between' })}
	`)}
`;

export const ListTitle = styled.p`
	color: ${({ configurator, theme, isHighlighted }) =>
		configurator
			? theme.graySoft
			: isHighlighted
			? theme.yellow
			: theme.graySemiSoft};
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.medium};

	${media.min.min(css`
		font-size: ${({ configurator }) => (configurator ? 2.2 : 1.4)}rem;
		padding-right: 5rem;
	`)}
`;

export const ListLink = styled.a`
	color: ${({ theme }) => theme.blueAzure};
	font-size: ${({ configurator }) => (configurator ? 1.6 : 1.2)}rem;

	${media.min.min(css`
		font-size: ${({ configurator }) => (configurator ? 2.2 : 1.4)}rem;
	`)}
`;
